var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-menu",class:_vm.className},[_c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"text":""}},'v-btn',attrs,false),on),[_vm._t("default")],2)]}}],null,true)},[_c('DropdownList',{attrs:{"config":_vm.config},on:{"action":_vm.actionHandler}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }